"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderBase = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const side_panel_1 = require("@alfalab/core-components/side-panel");
const typography_1 = require("@alfalab/core-components/typography");
const component_context_1 = require("../../context/component.context");
const typography_title_platform_1 = require("../../typography/typography-title-platform");
const index_module_css_1 = __importDefault(require("./index.module.css"));
/**
 * @private
 */
const HeaderBase = ({ CoreSidePanel = side_panel_1.SidePanel.Header, className, dataTestId, hasCloser = true, sticky = true, subtitle, title, rightAddons, bottomAddons, bottomAddonsClassName, }) => {
    const { platform, isMobile, isResponsive } = (0, react_1.useContext)(component_context_1.AdditionalContext);
    const platformStyles = {
        [index_module_css_1.default.mobile]: isMobile,
        [index_module_css_1.default.responsive]: isResponsive,
    };
    const headerContent = ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(index_module_css_1.default.titlesWrapper, platformStyles), children: (0, jsx_runtime_1.jsxs)("div", { children: [title && ((0, jsx_runtime_1.jsx)(typography_title_platform_1.TypographyTitlePlatform, { tag: 'h3', view: 'medium', color: 'primary', className: (0, classnames_1.default)(index_module_css_1.default.title, platformStyles), dataTestId: 'title', platform: platform, rowLimit: 3, children: title })), subtitle && ((0, jsx_runtime_1.jsx)(typography_1.Typography.Text, { className: (0, classnames_1.default)(index_module_css_1.default.subtitle, platformStyles), tag: 'div', view: 'primary-medium', color: 'secondary', dataTestId: 'subtitle', rowLimit: 2, children: subtitle }))] }) }));
    const headerProps = {
        className: (0, classnames_1.default)(index_module_css_1.default.component, {
            [index_module_css_1.default.withoutContent]: !title && !subtitle,
            [index_module_css_1.default.hasCloser]: hasCloser,
        }, className, platformStyles),
        dataTestId,
        hasCloser,
        sticky,
        rightAddons,
        closerClassName: (0, classnames_1.default)(index_module_css_1.default.closer, platformStyles, {
            [index_module_css_1.default.withoutRightAddons]: !rightAddons,
        }),
        contentClassName: index_module_css_1.default.content,
        addonClassName: (0, classnames_1.default)(index_module_css_1.default.addon, platformStyles),
        bottomAddons,
        bottomAddonsClassName: (0, classnames_1.default)(index_module_css_1.default.bottomSlot, platformStyles, bottomAddonsClassName),
    };
    return (0, jsx_runtime_1.jsx)(CoreSidePanel, Object.assign({}, headerProps, { children: headerContent }));
};
exports.HeaderBase = HeaderBase;
